var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BgImageLayout',{attrs:{"title":"Custom forms","page":_vm.__guide.forms,"icon-color":"white"}},[_c('AgGridWrapper',{attrs:{"options":_vm.gridOptions,"include-search-box":true,"actions":[
      {
        routeName: 'create-form',
        label: 'Create new Form',
        type: 'route',
        size: 'md'
      }
    ],"store-namespace":"forms"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }